<template>
  <div id="sign-in" class="has-text-centered">
    <c-hero/>
    <div>
      <p>
        <a href="/terms/" target="_blank">カチャログの利用規約</a>に同意して
      </p>
      <div class="has-text-centered">
        <button class="twitter button is-rounded is-c-operation is-large" @click="signInTwitter">
          Twitterアカウントで始める
        </button>
      </div>
      <div class="has-text-centered">
        <button class="google button is-rounded is-c-operation is-large" @click="signInGoogle">
          Googleアカウントで始める
        </button>
      </div>
      <div class="has-text-centered">
        <button class="facebook button is-rounded is-c-operation is-large" @click="signInFacebook">
          Facebookアカウントで始める
        </button>
      </div>
    </div>
    <c-footer></c-footer>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { fb, mixin } from './common.js'
import footer from './view/c-footer.vue'
import hero from '@/components/view/lp/hero'
export default {
  components: {
    'c-footer': footer,
    'c-hero': hero
  },
  mixins: [mixin],
  computed: Vuex.mapState({
    user: 'user',
    providerData: 'providerData'
  }),
  watch: {
    providerData (providerData) {
      if (providerData.uid && !providerData.isAnonymous) {
        this.$router.push({name: 'mypage'})
      }
    }
  },
  methods: {
    setLocalStorage () {
      function castPage (page) {
        page.pages_ref = page.pages_ref.path
        if (page.wishlists_ref) {
          page.wishlists_ref = page.wishlists_ref.path
        }
        return page
      }
      if (this.providerData.isAnonymous) {
        const wishlists = (this.user.wishlists || []).map(castPage)
        const histories = (this.user.histories || []).map(castPage)
        const receipts = (this.user.receipts || []).map(castPage)
        localStorage.wishlists = JSON.stringify(wishlists)
        localStorage.histories = JSON.stringify(histories)
        localStorage.receipts = JSON.stringify(receipts)
      }
    },
    signInTwitter () {
      this.$store.commit('enqueueAsync')
      this.setLocalStorage()
      const provider = new fb.auth.TwitterAuthProvider()
      fb.auth().signInWithRedirect(provider)
    },
    signInFacebook () {
      this.$store.commit('enqueueAsync')
      this.setLocalStorage()
      const provider = new fb.auth.FacebookAuthProvider()
      fb.auth().signInWithRedirect(provider)
    },
    signInGoogle () {
      this.$store.commit('enqueueAsync')
      this.setLocalStorage()
      const provider = new fb.auth.GoogleAuthProvider()
      fb.auth().signInWithRedirect(provider)
    }
  },
  created () {
    console.log('created cachalogSignIn')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sign-in.vue